import { render, staticRenderFns } from "./Retours.vue?vue&type=template&id=a59f0792&scoped=true&lang=true"
import script from "./Retours.vue?vue&type=script&lang=js"
export * from "./Retours.vue?vue&type=script&lang=js"
import style0 from "./Retours.vue?vue&type=style&index=0&id=a59f0792&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59f0792",
  null
  
)

export default component.exports